// extracted by mini-css-extract-plugin
export var compactFilters = "_ez-4";
export var detailImage = "_ez-1";
export var dropdownContainer = "_ez-2";
export var imageContainer = "_ez-0";
export var selectedCard = "_ez-3";